import SetPasswordScreen from 'features/auth/resetPassword/screens/SetPassword/SetPasswordScreen';
import React from 'react';

export default function Page() {
  return <SetPasswordScreen />;
}
